import { ArrowLeft } from 'lucide-react';

interface HeaderProps {
  onNavigateToOverview: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onNavigateToOverview }) => (
  <header className="mb-8" role="banner">
    <button
      onClick={onNavigateToOverview}
      className="btn-secondary inline-flex items-center gap-2 mb-6"
      aria-label="Navigate back to overview"
    >
      <ArrowLeft className="w-4 h-4" />
      <span>Back to Overview</span>
    </button>

    <div className="max-w-7xl mx-auto">
      <h1 className="text-3xl font-bold transition-colors duration-200 text-primary mb-2">
        Select Fixes
      </h1>
      <p className="text-sm transition-colors duration-200 text-secondary">
        Choose the recommendations you'd like to implement
      </p>
    </div>
  </header>
);
